module.exports = __webpack_public_path__ + "static/media/play2.49e80660.png";